module.exports = __webpack_public_path__ + "img/stock3.56d8b715.png";